var _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeMain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-18"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.44,
    y: 391.92,
    width: 26,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 389.21,
    width: 54.1,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.12,
    y: 401.21,
    width: 26.32,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.23,
    y: 399.53,
    width: 38.83,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.96,
    y: 399.53,
    width: 10.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.35,
    y: 395.31,
    width: 54.56,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.06,
    y: 248.05,
    width: 45.65,
    height: 125.47,
    transform: "translate(807.77 621.58) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.74,
    y: 373.53,
    width: 236.21,
    height: 8.87,
    transform: "translate(599.68 755.92) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.97,
    y: 248.05,
    width: 208.09,
    height: 125.47,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.97,
    y: 256.55,
    width: 208.89,
    height: 45.93,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.97,
    y: 310.85,
    width: 208.89,
    height: 45.93,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.06,
    y: 256.55,
    width: 7.9,
    height: 45.93,
    transform: "translate(770.02 559.02) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.06,
    y: 310.85,
    width: 7.9,
    height: 45.93,
    transform: "translate(770.02 667.62) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.89,
    y: 240.33,
    width: 214.17,
    height: 7.72,
    transform: "translate(547.95 488.38) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.06,
    y: 240.33,
    width: 52.03,
    height: 7.72,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.14,
    y: 81.68,
    width: 107.43,
    height: 135.04,
    transform: "translate(763.72 298.41) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.43,
    y: 81.68,
    width: 127.03,
    height: 135.04,
    transform: "translate(735.89 298.41) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.06,
    y: 96.33,
    width: 113.76,
    height: 105.75,
    transform: "translate(218.74 517.15) rotate(-90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.65,161.52l20.21-9.37v-5.89l-20.21-9.39v7.06l12.28,5.29-12.28,5.29Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.47,134.15h-3.69l6.54,30.11H373Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.23,154.51,344,149.22l12.28-5.29v-7.06L336,146.26v5.89l20.21,9.37Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.21,
    y: 153.22,
    width: 7.04,
    height: 229.18,
    transform: "translate(241.47 535.62) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.75,380.8l-.19-1a5.58,5.58,0,0,0,3.33-2.91c1.83-3.24,2.94-10.15-2.15-24.63-7.84-22.32-3.16-40.32,6.17-76.2,1.62-6.25,3.46-13.33,5.37-21,7.17-28.67.54-46.45-4.79-60.74-4.13-11.09-7.4-19.85-3.22-30l.93.38c-4,9.78-.83,18.38,3.23,29.27,5.38,14.41,12.07,32.36,4.82,61.32-1.91,7.66-3.75,14.74-5.37,21C114.6,312,109.94,329.92,117.69,352c5.23,14.89,4,22.09,2,25.5A6.48,6.48,0,0,1,115.75,380.8Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.99 382.4 133.48 382.4 126.39 378.22 115.08 378.22 107.99 382.4",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "70.31 182.41 171.16 182.41 160.06 97.67 81.41 97.67 70.31 182.41",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.88 196.38 273.72 196.38 266.63 240.33 226.97 240.33 219.88 196.38",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.51,210.68c14.68-5.31,25.92-13.29,13.34-29.44s-32.07-16.07-45.21-8.92c-16.74,9.1-13.38,35.45-13.38,35.45S226.83,216,241.51,210.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.78,196c-11.23-7.65-19.19-16.5-6.16-25.84s29.1-4.55,38.76,4.12c12.31,11.06,5.2,30.47,5.2,30.47S267,203.61,255.78,196Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236,176.59c13.14-.79,24.16-4.22,17.94-18.45s-22-18.22-34.31-15.78c-15.73,3.11-19.44,22.79-19.44,22.79S222.87,177.39,236,176.59Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.5,168.2c-10.93-3.52-19.5-8.79-11.17-19.48s22.5-10.63,32.4-5.91c12.62,6,11.5,23.46,11.5,23.46S263.43,171.71,252.5,168.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,150c10.91,3.6,20.94,4.38,20.49-9.16S240.58,119,229.8,116.94c-13.75-2.56-23.11,12.19-23.11,12.19S221.11,146.37,232,150Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.69,144.15c-7.81.54-14.56-.64-12-9.51s11.56-12.4,19-11.91c9.5.63,13.19,12,13.19,12S267.49,143.62,259.69,144.15Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-18"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-18",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-18"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79.51,
    y: 251.09,
    width: 339.75,
    height: 12.19,
    style: {
      fill: "#C140FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.51,
    y: 251.09,
    width: 90.93,
    height: 12.19,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.89 263.28 163.98 263.28 168.12 416.06 171.89 416.06 175.66 416.06 179.81 263.28 171.89 263.28",
    style: {
      fill: "#C140FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.12 416.06 171.89 416.06 171.89 266.56 164.11 267.98 168.12 416.06",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.92 263.28 89.01 263.28 93.15 416.06 96.92 416.06 100.69 416.06 104.83 263.28 96.92 263.28",
    style: {
      fill: "#C140FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.15 416.06 96.92 416.06 96.92 266.56 89.13 267.98 93.15 416.06",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "401.85 263.28 393.94 263.28 398.08 416.06 401.85 416.06 405.62 416.06 409.77 263.28 401.85 263.28",
    style: {
      fill: "#C140FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.08 416.06 401.85 416.06 401.85 266.56 394.07 267.98 398.08 416.06",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "326.88 263.28 318.97 263.28 323.11 416.06 326.88 416.06 330.65 416.06 334.79 263.28 326.88 263.28",
    style: {
      fill: "#C140FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.11 416.06 326.88 416.06 326.88 266.56 319.1 267.98 323.11 416.06",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.78,185.83H160a4.16,4.16,0,0,0-4.17,5.28l10.76,51.35a6.87,6.87,0,0,0,6.38,5.27h80.84a4.16,4.16,0,0,0,4.17-5.27l-10.77-51.35A6.87,6.87,0,0,0,240.78,185.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.67,244.8a4.79,4.79,0,0,1-4.32-3.6l-10.76-51.35a2.35,2.35,0,0,1,.37-2,2.17,2.17,0,0,1,1.73-.73h80.84a4.79,4.79,0,0,1,4.32,3.6l10.76,51.35a2.35,2.35,0,0,1-.37,2,2.14,2.14,0,0,1-1.73.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.66,240.69,224.46,192a2,2,0,0,1,1.94-2.39h13.12a2,2,0,0,1,1.94,1.58l10.2,48.65a2,2,0,0,1-1.94,2.39H236.6A2,2,0,0,1,234.66,240.69Z",
    style: {
      fill: "#C140FF",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.32 193.87 164.88 191.76 181.08 191.76 181.52 193.87 165.32 193.87",
    style: {
      fill: "#C140FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.8 199.11 172.36 197 200.75 197 201.2 199.11 172.8 199.11",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.3 204.34 173.85 202.23 205.68 202.23 206.12 204.34 174.3 204.34",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "175.79 209.58 175.35 207.47 200.97 207.47 201.42 209.58 175.79 209.58",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.25 218.07 169.8 215.96 180.05 215.96 180.49 218.07 170.25 218.07",
    style: {
      fill: "#C140FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "177.72 223.3 177.28 221.19 189.76 221.19 190.21 223.3 177.72 223.3",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.2 223.3 192.75 221.19 205.24 221.19 205.68 223.3 193.2 223.3",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "179.22 228.54 178.78 226.43 220.98 226.43 221.42 228.54 179.22 228.54",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.71 233.77 180.27 231.66 212.45 231.66 212.89 233.77 180.71 233.77",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.52,247.42H172.16c-2.9,0-4.78,1.65-4.17,3.67H284.9C284.3,249.07,281.42,247.42,278.52,247.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.21,172.85,127,124.19a2,2,0,0,1,1.94-2.38h82.6a2,2,0,0,1,1.94,1.57L223.69,172a2,2,0,0,1-1.94,2.39h-82.6A2,2,0,0,1,137.21,172.85Z",
    style: {
      fill: "#C140FF",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "166.57 123.41 149.23 123.41 148.84 121.54 166.18 121.54 166.57 123.41",
    style: {
      fill: "#C140FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.75 126.39 156.79 126.39 156.4 124.52 163.36 124.52 163.75 126.39",
    style: {
      fill: "#C140FF",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "175.33 126.39 164.61 126.39 164.22 124.52 174.94 124.52 175.33 126.39",
    style: {
      fill: "#C140FF",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180 129.36 157.41 129.36 157.02 127.49 179.62 127.49 180 129.36",
    style: {
      fill: "#C140FF",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "177.13 132.34 158.03 132.34 157.64 130.47 176.74 130.47 177.13 132.34",
    style: {
      fill: "#C140FF",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.8 163.95 177.64 163.95 178.03 165.81 190.19 165.81 189.8 163.95",
    style: {
      fill: "#C140FF",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.64 159.87 156.83 159.87 156.44 158 174.25 158 174.64 159.87",
    style: {
      fill: "#C140FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "181.8 166.92 165.24 166.92 165.63 168.79 182.19 168.79 181.8 166.92",
    style: {
      fill: "#C140FF",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.78 163.95 164.62 163.95 165.01 165.81 177.17 165.81 176.78 163.95",
    style: {
      fill: "#C140FF",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "188.32 160.97 164 160.97 164.39 162.84 188.71 162.84 188.32 160.97",
    style: {
      fill: "#C140FF",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.96 109.53 146.34 109.53 145.95 107.67 165.57 107.67 165.96 109.53",
    style: {
      fill: "#C140FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "175.65 116.59 154.01 116.59 154.4 118.46 176.03 118.46 175.65 116.59",
    style: {
      fill: "#C140FF",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.32 113.62 153.39 113.62 153.78 115.48 171.71 115.48 171.32 113.62",
    style: {
      fill: "#C140FF",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.51 110.64 152.77 110.64 153.16 112.51 172.9 112.51 172.51 110.64",
    style: {
      fill: "#C140FF",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.74 137.18 152.1 137.18 151.71 135.31 165.35 135.31 165.74 137.18",
    style: {
      fill: "#C140FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.16 144.23 160.51 144.23 160.9 146.1 187.54 146.1 187.16 144.23",
    style: {
      fill: "#C140FF",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.93 141.26 159.89 141.26 160.28 143.13 171.32 143.13 170.93 141.26",
    style: {
      fill: "#C140FF",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.91 141.26 171.87 141.26 172.26 143.13 183.3 143.13 182.91 141.26",
    style: {
      fill: "#C140FF",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.59 138.28 159.27 138.28 159.66 140.15 183.97 140.15 183.59 138.28",
    style: {
      fill: "#C140FF",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.54 153.16 162.37 153.16 162.76 155.02 183.93 155.02 183.54 153.16",
    style: {
      fill: "#C140FF",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.91 150.18 161.75 150.18 162.14 152.05 168.29 152.05 167.91 150.18",
    style: {
      fill: "#C140FF",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "177.54 150.18 168.75 150.18 169.14 152.05 177.93 152.05 177.54 150.18",
    style: {
      fill: "#C140FF",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "185.45 147.21 161.13 147.21 161.52 149.07 185.84 149.07 185.45 147.21",
    style: {
      fill: "#C140FF",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.6 146.71 195.89 146.71 195.5 144.84 204.22 144.84 204.6 146.71",
    style: {
      fill: "#C140FF",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.1 146.71 205.68 146.71 205.29 144.84 218.71 144.84 219.1 146.71",
    style: {
      fill: "#C140FF",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.8 149.69 196.51 149.69 196.12 147.82 224.41 147.82 224.8 149.69",
    style: {
      fill: "#C140FF",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.04 152.66 197.13 152.66 196.74 150.79 220.65 150.79 221.04 152.66",
    style: {
      fill: "#C140FF",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "231.75 134.88 204.66 134.88 205.05 136.74 232.14 136.74 231.75 134.88",
    style: {
      fill: "#C140FF",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.49 131.9 204.04 131.9 204.43 133.77 226.87 133.77 226.49 131.9",
    style: {
      fill: "#C140FF",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "222.43 128.93 197.71 128.93 198.1 130.79 222.82 130.79 222.43 128.93",
    style: {
      fill: "#C140FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "232.97 164.56 199.61 164.56 200 166.43 233.36 166.43 232.97 164.56",
    style: {
      fill: "#C140FF",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.81 161.59 198.99 161.59 199.38 163.45 213.2 163.45 212.81 161.59",
    style: {
      fill: "#C140FF",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "227.81 161.59 213.99 161.59 214.38 163.45 228.2 163.45 227.81 161.59",
    style: {
      fill: "#C140FF",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.81 158.61 198.37 158.61 198.76 160.48 229.2 160.48 228.81 158.61",
    style: {
      fill: "#C140FF",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "227.97 173.48 201.47 173.48 201.86 175.35 228.36 175.35 227.97 173.48",
    style: {
      fill: "#C140FF",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.56 170.51 200.85 170.51 201.24 172.38 208.95 172.38 208.56 170.51",
    style: {
      fill: "#C140FF",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "220.62 170.51 209.62 170.51 210.01 172.38 221.01 172.38 220.62 170.51",
    style: {
      fill: "#C140FF",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "230.68 167.53 200.23 167.53 200.62 169.4 231.06 169.4 230.68 167.53",
    style: {
      fill: "#C140FF",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "149.6 175.79 128.86 175.79 129.25 177.66 149.99 177.66 149.6 175.79",
    style: {
      fill: "#C140FF",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.47 172.82 128.24 172.82 128.63 174.68 143.85 174.68 143.47 172.82",
    style: {
      fill: "#C140FF",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.76 172.82 144.54 172.82 144.93 174.68 160.16 174.68 159.76 172.82",
    style: {
      fill: "#C140FF",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.07 169.84 127.62 169.84 128.01 171.71 158.45 171.71 158.07 169.84",
    style: {
      fill: "#C140FF",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.95 231.66 378.11 231.66 379.61 251.09 389.45 251.09 390.95 231.66",
    style: {
      fill: "#C140FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.95 231.66 378.11 231.66 379.61 251.09 389.45 251.09 390.95 231.66",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.13 218.17 129.59 218.17 123.29 251.09 104.83 251.09 111.13 218.17",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.64 209.35 108.57 209.35 115.87 251.09 141.94 251.09 134.64 209.35",
    style: {
      fill: "#C140FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.03 209.35 108.57 209.35 115.87 251.09 114.33 251.09 107.03 209.35",
    style: {
      fill: "#C140FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.03 209.35 108.57 209.35 115.87 251.09 114.33 251.09 107.03 209.35",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "119.62 246.62 113.88 213.81 130.9 213.81 136.63 246.62 119.62 246.62",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "135.82 246.62 130.09 213.81 130.9 213.81 136.63 246.62 135.82 246.62",
    style: {
      fill: "#C140FF",
      opacity: 0.6000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.77,156c.37.8.25,1.65-.28,1.89s-1.25-.21-1.62-1-.24-1.65.28-1.89S263.4,155.16,263.77,156Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.09,157.58s.32,5.46-.66,8.62c2,.67,4.16-1,4.16-1Z",
    style: {
      fill: "#ff5652"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.87,149.39a.53.53,0,0,1-.3.12,4.12,4.12,0,0,0-3.29,1.79.52.52,0,1,1-.9-.52,5.14,5.14,0,0,1,4.13-2.31.52.52,0,0,1,.36.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.22,154.76c3.09,10.7,6.54,19,10.75,23.74,0,0,.08,8.41-14.25,12.41-15.76,4.4-9.72-5.72-9.72-5.72,8-4.45,7.24-11.17,1.22-13.73Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.31,176.45c-.28-3.91-.65-8.37-3.06-8.49-2.66-.12-18.06,6.76-21.35,11.61s3.14,9.6,3.14,9.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.79,237l-13.3-.44.24,11.14s11.6-1.2,12.11-4.25Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.46 242.03 254.06 247.73 262.73 247.71 262.49 236.57 255.46 242.03",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.17,190.71l-.28,2.86c-.09.92-.21,1.82-.33,2.73-.23,1.81-.52,3.62-.83,5.42-.6,3.61-1.38,7.2-2.28,10.81a107.83,107.83,0,0,1-3.32,10.87c-.69,1.83-1.41,3.66-2.27,5.52a45.73,45.73,0,0,1-3,5.65c-.27.47-.61,1-.94,1.44s-.65,1-1,1.46-.72,1-1.18,1.47l-.65.74a10.06,10.06,0,0,1-.74.78,22.81,22.81,0,0,1-6.93,4.65,41,41,0,0,1-12.43,3.15c-1.95.23-3.88.32-5.77.37s-3.78,0-5.64-.1-3.7-.26-5.53-.48-3.61-.51-5.55-.9l.32-10.45a160.33,160.33,0,0,0,18.9-4.5,41.44,41.44,0,0,0,4.06-1.56,18.63,18.63,0,0,0,3.22-1.75,4.48,4.48,0,0,0,1.46-1.42l.29-.46a6.53,6.53,0,0,0,.37-.61,7.56,7.56,0,0,0,.39-.71c.13-.26.27-.5.4-.79a52.59,52.59,0,0,0,2.89-7.94c.82-2.94,1.59-6,2.21-9.17s1.22-6.37,1.77-9.6l.76-4.86.69-4.73Z",
    style: {
      fill: "#C140FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.17,190.71l-.28,2.86c-.09.92-.21,1.82-.33,2.73-.23,1.81-.52,3.62-.83,5.42-.6,3.61-1.38,7.2-2.28,10.81a107.83,107.83,0,0,1-3.32,10.87c-.69,1.83-1.41,3.66-2.27,5.52a45.73,45.73,0,0,1-3,5.65c-.27.47-.61,1-.94,1.44s-.65,1-1,1.46-.72,1-1.18,1.47l-.65.74a10.06,10.06,0,0,1-.74.78,22.81,22.81,0,0,1-6.93,4.65,41,41,0,0,1-12.43,3.15c-1.95.23-3.88.32-5.77.37s-3.78,0-5.64-.1-3.7-.26-5.53-.48-3.61-.51-5.55-.9l.32-10.45a160.33,160.33,0,0,0,18.9-4.5,41.44,41.44,0,0,0,4.06-1.56,18.63,18.63,0,0,0,3.22-1.75,4.48,4.48,0,0,0,1.46-1.42l.29-.46a6.53,6.53,0,0,0,.37-.61,7.56,7.56,0,0,0,.39-.71c.13-.26.27-.5.4-.79a52.59,52.59,0,0,0,2.89-7.94c.82-2.94,1.59-6,2.21-9.17s1.22-6.37,1.77-9.6l.76-4.86.69-4.73Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.12,204a326.55,326.55,0,0,1,8.33,65.14H337c.32-7.23-.9-48-6.79-77.45a20.4,20.4,0,0,0-24.4-16l-.28.07c-7.31,1.66-17.8,4.34-24,6.69l-.25.1A18.33,18.33,0,0,0,270.12,204Z",
    style: {
      fill: "#C140FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.93,222.7c.46,2.81.93,5.79,1.36,8.91,4.79-5,6.31-20.32,6.31-20.32Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.29,237.73,212,236.49l-.44,11.13A12.48,12.48,0,0,0,224,244.11Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.68 239.77 201.42 247.42 211.6 247.62 212.04 236.49 205.68 239.77",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.09,198.87c-.92,1.75-1.74,3.3-2.66,4.9s-1.8,3.16-2.75,4.71c-1.88,3.12-3.83,6.18-5.89,9.21a153.64,153.64,0,0,1-13.71,17.64,75.7,75.7,0,0,1-8.69,8.27c-.39.33-.85.65-1.28,1s-.81.63-1.45,1-1.18.74-1.76,1.06-1.18.61-1.77.87a31.42,31.42,0,0,1-6.88,2.09,43.44,43.44,0,0,1-12.52.28,52,52,0,0,1-5.8-1q-1.43-.33-2.82-.75c-1-.28-1.81-.59-2.88-1l1.65-10.32c6.28-.85,13.07-1.94,17.75-4.06a12.83,12.83,0,0,0,2.91-1.67,6.81,6.81,0,0,0,1-.84c.07-.09.38-.36.61-.58s.5-.43.75-.69a71.37,71.37,0,0,0,6-6.75,195.49,195.49,0,0,0,11.27-16.16c1.8-2.83,3.55-5.71,5.3-8.6l2.58-4.34,2.49-4.27Z",
    style: {
      fill: "#C140FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "276.02 407.6 265.08 407.6 259.57 382.25 270.52 382.25 276.02 407.6",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.47,405.26h12.3a1,1,0,0,1,.93.74l2.16,9.74a1.6,1.6,0,0,1-1.6,1.94c-4.29-.07-6.38-.32-11.79-.32-3.33,0-7.6.34-12.19.34s-5.2-4.54-3.32-4.95c8.44-1.85,9-4.39,11.73-6.82A2.64,2.64,0,0,1,264.47,405.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "270.53 382.26 259.57 382.26 262.63 396.3 273.37 395.33 270.53 382.26"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M289.71,141.9c4,10.12,6.78,15.85,4.14,23.2-4,11.05-18.19,12.17-25.09,3.43-6.2-7.87-11.62-23.1-3.79-31.47A14.81,14.81,0,0,1,289.71,141.9Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.49,157.06c-1.64,2.2-2.9,3.87-2.9,3.87s-3.37-8.37-2.08-12.21c-1.64-3.25-4.95,1.54-6.2-4.79s4.16-13.13,6.2-14.54a7.41,7.41,0,0,1,.28,2.27,28,28,0,0,1,19.6-6.19,6.77,6.77,0,0,0-1.1,2.94s11.87,2,14.57,8.72a12.83,12.83,0,0,0-3-1,14.49,14.49,0,0,1,2.4,10.72,110.21,110.21,0,0,0-1.34,16.53c.11,2.84-7.68,8.27-12.43,2.47S270.49,157.06,270.49,157.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.44,154.88a11.07,11.07,0,0,1-.5,7.1c-1.27,3-3.88,2.28-5.17-.34-1.17-2.35-1.92-6.71.15-8.8S274.66,152.05,275.44,154.88Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296,269.1s-50.84,18.44-52.33,42.83c-2.76,44.93,15.61,80.5,15.61,80.5l16.84-1.8s-3-14.46-5.23-55.16c-2.81-51.15,84,1.2,66.12-66.37Z",
    style: {
      fill: "#C140FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296,269.1s-50.84,18.44-52.33,42.83c-2.76,44.93,15.61,80.5,15.61,80.5l16.84-1.8s-3-14.46-5.23-55.16c-2.81-51.15,84,1.2,66.12-66.37Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.62,386.23c-.08,0,2.68,7.48,2.68,7.48l21-2.06-1.05-6.8Z",
    style: {
      fill: "#C140FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.73 408.85 217.78 408.85 214.58 383.49 225.53 383.49 228.73 408.85",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.7,405.25h12a.94.94,0,0,1,.93.74l2.18,9.73a1.59,1.59,0,0,1-1.57,2c-4.31-.07-10.55-.31-16-.3-6.34,0-7.55.35-15,.36-4.5,0-5.75-4.53-3.87-5,8.56-1.88,11.3-2.09,18.69-6.66A5,5,0,0,1,217.7,405.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.59 383.5 216.33 397.31 227.19 396.57 225.54 383.5 214.59 383.5",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.45,269.1s-83.3,7.39-82.4,49.23c.93,43.52,17.19,72.87,17.19,72.87H229.5s-3.08-22.58-2.53-65.42c.16-12.83,26.1-17.07,51.42-18.57,21.88-1.3,42.36-13.77,50.86-34L331,269.1Z",
    style: {
      fill: "#C140FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.45,269.1s-83.3,7.39-82.4,49.23c.93,43.52,17.19,72.87,17.19,72.87H229.5s-3.08-22.58-2.53-65.42c.16-12.83,26.1-17.07,51.42-18.57,21.88-1.3,42.36-13.77,50.86-34L331,269.1Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.43,386.83c-.07,0,2.79,7.52,2.79,7.52l19.64-1.41-1.15-6.8Z",
    style: {
      fill: "#C140FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.32,222.08l-10.57,40.73a127.1,127.1,0,0,0-4.06,31.95v18.93c0,4.78,3.52,8.66,7.87,8.66h54.18c4.35,0,7.87-3.88,7.87-8.66V294.76a127.11,127.11,0,0,1,4.07-31.95l9.33-36c1.44-5.53-2.34-11-7.57-11H307.88A8,8,0,0,0,300.32,222.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.93,302.63l1.77,10.1c.94,5.31,5.61,9.62,10.44,9.62h60.23c4.83,0,8-4.31,7.06-9.62l-1.77-10.1c-1.07-6.05-6.38-10.95-11.88-10.95H241C235.46,291.68,231.87,296.58,232.93,302.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.17 332.49 279.62 332.49 276.54 322.35 314.25 322.35 311.17 332.49",
    style: {
      fill: "#C140FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.76,
    y: 332.49,
    width: 11.27,
    height: 75.41,
    style: {
      fill: "#C140FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "301.03 407.9 289.76 407.9 289.76 334.3 301.03 335.45 301.03 407.9",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "298.28 407.9 295.59 407.9 295.59 334.89 298.28 335.17 298.28 407.9",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.31,419.56H269.47a1.44,1.44,0,0,1-.84-2.6l8.22-6a23.08,23.08,0,0,1,13.62-4.46h9.85a23.07,23.07,0,0,1,13.61,4.46l8.23,6A1.44,1.44,0,0,1,321.31,419.56Z",
    style: {
      fill: "#C140FF"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeMain);
export default __webpack_public_path__ + "static/media/home-main.ed3e9d0c85c89dfa4c5afc42c8c06409.svg";
export { ForwardRef as ReactComponent };